/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Error_MinInputs */

const en_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least 2 regions to compare.`)
};

const de_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle mindestens 2 Regionen zum Vergleichen.`)
};

const fr_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne au moins 2 régions à comparer.`)
};

const es_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione al menos 2 regiones para comparar.`)
};

const it_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona almeno 2 regioni per confrontare.`)
};

const nl_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer minimaal 2 regio's om te vergelijken.`)
};

const pl_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz co najmniej 2 regiony do porównania.`)
};

const fi_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse vähintään 2 aluetta vertailtavaksi.`)
};

const da_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg mindst 2 regioner at sammenligne.`)
};

const sv_salary_compare_error_min = /** @type {(inputs: Salary_Compare_Error_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj minst 2 regioner att jämföra.`)
};

/**
* | output |
* | --- |
* | "Select at least 2 regions to compare." |
*
* @param {Salary_Compare_Error_MinInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_error_min = /** @type {((inputs?: Salary_Compare_Error_MinInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Error_MinInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_error_min(inputs)
	if (locale === "fr") return fr_salary_compare_error_min(inputs)
	if (locale === "es") return es_salary_compare_error_min(inputs)
	if (locale === "it") return it_salary_compare_error_min(inputs)
	if (locale === "nl") return nl_salary_compare_error_min(inputs)
	if (locale === "pl") return pl_salary_compare_error_min(inputs)
	if (locale === "fi") return fi_salary_compare_error_min(inputs)
	if (locale === "da") return da_salary_compare_error_min(inputs)
	if (locale === "sv") return sv_salary_compare_error_min(inputs)
	return en_salary_compare_error_min(inputs)
});